/** @module SiteAdmin/CommentsPopupController */
define([
	"dojo/_base/declare",
	"underscore",
	"csi/def/ViewRef",
	"csi/html",
	"csi/state/rootStore",
	"csi/table/Popup",
	"csi/xml",
	"csi/xml/Query",
	"csi/xml/QueryProcessor"
], function(declare, _, ViewRef, html, { sessionStore }, Popup, xml, Query, QueryProcessor) {

	return declare(Popup, {
		popupForceBrowse: true,
		popupLinkTarget: "_blank",

		/** @property {number} numberOfRecentComments - number of recent comments to store in RecentComments/RecentChildComments */
		numberOfRecentComments: 5,

		/** @property {string} urlComment - URL for selected comment, if one */
		urlComment: null,

		/**
		 * @override
		 * Determine ViewRef for action based on current node. If derived from DocAndCommentOwner, then need to add path to 
		 * get to DocumentContainer
		 */
		getActionView: function(vr) {
			var node = this.getNode();
			vr = new ViewRef();
			vr.m_id = "Comments";

			if (node.DocumentsAndComments) {
				vr.m_url = node.DocumentsAndComments;
			}

			return this.inherited(arguments, [vr]);
		},

		/**
		 * @override
		 * If invoked from a comment, then store comment to be focused and reset
		 * controller URL to that of Comments cell 
		 */
		preProcess: function() {
			if (this.getNode().$Type == "Comment") {
				this.urlComment = this.m_urlNode;
				this.m_urlNode = html.getElementContext(this.refNode);
			}

			this.inherited(arguments);
		},

		/**
		 * @override
		 * Focus on selected comment
		 */
		onLoadPopup: function(view) {
			this.inherited(arguments);

			if (this.urlComment) {
				view.focusComment(this.urlComment);
			}
		},

		/**
		 * @override
		 * Redraw to show new comments after updating recent comments with latest changes;
		 * the rollup service may not be caught up, so client needs to do this itself
		 */
		postProcessSuccess: function() {
			var id = this.heading.m_id;
			var node = this.getNode();
			var urls = node[id];
			var size = Math.max(urls.length, this.numberOfRecentComments);
			var store = this.popupView.get("store");
			var comments = store.getResultNodes();
			var sortQuery = new Query().SortByAttr("Date", xml.path("LastPost"), null, true);
			var sortedComments = QueryProcessor.applyQueryToNodes(sortQuery, comments, this.m_cache);
			var recentComments = sortedComments.slice(0, size);

			// the decision for now is to not mark this as evaluated (pass true as 4th parameter) so that a view refresh
			// will go back to the latest value
			xml.nodeAttributeSetValue(node, id, _.pluck(recentComments, store.urlProperty));

			// force current user (Author) to be cached to update its timestamp so it will not be considered out of date when redrawn
			// and thus create request to the server
			this.m_cache.put(sessionStore.currentUser);

			this.widget.redrawNode(this.refNode);
		}
	});
});